import { showFormDialog } from '@juvare/common-form-ui/showFormDialog';
import { showAlertDialog } from '@juvare/common-web-ui/DialogHelper';
import { handleErrorSnackbar, showAlertSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
export function showCheckOutDialog(params) {
    showFormDialog({
        title: params.t('checkOutDialog.title'),
        fullWidth: params.mobileScreen,
        config: {
            type: 'form',
            children: [
                {
                    type: 'form.text',
                    key: 'checkOutComment',
                    label: 'Comment',
                },
            ],
        },
        onSubmit: (data) => params.storage.get(params.id).then((result) => {
            if (result.columns.checkOutUserId) {
                showAlertDialog({
                    title: params.t('checkOutDialog.cannotCheckOutTitle'),
                    content: params.t('checkOutDialog.cannotCheckOutContent', {
                        checkOutUserDisplayName: result.columns.checkOutUserDisplayName,
                    }),
                });
                return;
            }
            params.storage
                .post({
                action: 'partial-update',
                id: params.id,
                data: Object.assign(Object.assign({}, data), { checkOutUserId: params.currentUserId }),
            })
                .then((response) => {
                showAlertSnackbar({
                    horizontalPosition: 'center',
                    type: 'success',
                    verticalPosition: 'bottom',
                    autoHideDuration: 2000,
                    message: params.t('checkOutDialog.checkedOutSnackbar'),
                });
                params.onSuccess(response);
            })
                .catch(handleErrorSnackbar);
        }),
    });
}
